import React from 'react';

export const intellectualPropertyRightsMessages = {
  value: 'Intellectual Property Rights',
  list: [
    {
      value: (
        <>
          All contents of the Site, including without limitation information,
          text, graphics, images, layout, designs, pictures, logos, editorial
          content, HTML and other proprietary materials on the Site
          (collectively “Contents”) are the intellectual property of Glints or
          its licensors and are protected by copyright, trademark, patent and
          other intellectual property laws. Users acknowledge and agree that the
          Contents are made available solely for their personal non-commercial
          use. Except as otherwise provided in this paragraph, users shall not,
          and shall not procure, assist or facilitate any third party to, copy,
          reproduce, transmit, publish, disseminate, distribute, redistribute,
          broadcast, circulate, store (in any medium), display, modify, sell or
          transfer or participate in the sale or transfer of or offer for sale
          of, create derivative works from, or in any way exploit any of the
          Contents, whether in whole or in part. Users may download or copy the
          Contents solely for their personal non-commercial use and/or users
          that are expressly permitted in these Terms and Conditions, provided
          that users will not delete or amend any symbols or statements in the
          Contents that indicate the subsistence therein of copyright, trademark
          and any other proprietary rights. Users do not have any right, title
          or interest in or to any or any part of the Contents as a result of
          such downloading or copying. Glints reserves all its rights of
          enforcement of all its intellectual property rights or proprietary
          rights in the Contents, including without limitation against any use
          of any of the Contents that is not expressly permitted under the Terms
          and Conditions. For the avoidance of doubt, any purported consent of
          any third parties (including Advertisers) to the use of the Contents
          or any part thereof shall not in any way exonerate the users from the
          restrictions/prohibitions imposed hereunder in whatsoever manner.
        </>
      ),
    },
  ],
};
